import { call, getContext, put, takeEvery } from "redux-saga/effects";

import { CONTEXT } from "@const/redux";
import {
  getSuggestedLivestreamsActionTypes,
  getSuggestedLivestreamsPortionActionTypes,
} from "./actionTypes";
import {
  getSuggestedLivestreamsFailure,
  getSuggestedLivestreamsPortionFailure,
  getSuggestedLivestreamsPortionSuccess,
  getSuggestedLivestreamsSuccess,
} from "./actions";

const getSuggestLivestreamAsync = ({ LivestreamsService, params }) => {
  if (!LivestreamsService) {
    console.log("Required services does not exist");

    return;
  }

  return LivestreamsService.getStreams(params);
};

function* getSuggestedLivestreams({ payload }) {
  try {
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    const { ...params } = payload;

    const { data, pagination } = yield call(getSuggestLivestreamAsync, {
      LivestreamsService,
      params,
    });

    yield put(
      getSuggestedLivestreamsSuccess({
        data,
        ...pagination,
      }),
    );
  } catch (error) {
    console.log({ error });
    yield put(getSuggestedLivestreamsFailure(error));
  }
}

function* getSuggestedLivestreamsPortion({ payload }) {
  try {
    const { LivestreamsService } = yield getContext(CONTEXT.SERVICES);
    const { ...params } = payload;

    const { data, pagination } = yield call(getSuggestLivestreamAsync, {
      LivestreamsService,
      params,
    });

    yield put(getSuggestedLivestreamsPortionSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getSuggestedLivestreamsPortionFailure(error));
  }
}

export function* watchGetSuggestedLivestreams() {
  yield takeEvery(
    getSuggestedLivestreamsActionTypes.request,
    getSuggestedLivestreams,
  );
}

export function* watchGetSuggestedLivestreamsPortion() {
  yield takeEvery(
    getSuggestedLivestreamsPortionActionTypes.request,
    getSuggestedLivestreamsPortion,
  );
}
